"use client";

import { useEffect } from "react";
import Script from "next/script";
import api from '@/lib/api'
export default function GoogleLogin() {
  useEffect(() => {

    const handleOAuthCallback = async (code: string) => {
      try {
        const data = await api.post('/oauth/google/login/id-token', { idToken: code })
        if (data.tokens.accessToken) {
          typeof window !== "undefined" && localStorage.setItem('userInfo', data.userInfo)
          typeof window !== "undefined" && localStorage.setItem('token', data.tokens.accessToken)
          setTimeout(()=> {
            window.location.reload();
          }, 1000)
        }
      } catch (error) {
        console.error('OAuth callback failed:', error)
      }
    }

    window.handleCredentialResponse = (response) => {
      console.log("Encoded JWT ID token:", response.credential);
      handleOAuthCallback(response.credential);
      // const user = parseJwt(response.credential);
      // console.log("User Info:", user);
    };

    // function parseJwt(token) {
    //   const base64Url = token.split(".")[1];
    //   const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    //   return JSON.parse(
    //     decodeURIComponent(
    //       atob(base64)
    //         .split("")
    //         .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
    //         .join("")
    //     )
    //   );
    // }
  }, []);

  return (
    <>
      <Script
        src="https://accounts.google.com/gsi/client"
        strategy="afterInteractive"
      />
      <div
        id="g_id_onload"
        data-client_id="7392438826-eobabbu7nhif569o1urgbfngo1vfrbf2.apps.googleusercontent.com"
        data-context="signin"
        data-ux_mode="popup"
        data-callback="handleCredentialResponse"
      />
      {/* <div className="g_id_signin" data-type="standard" /> */}
    </>
  );
}